<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      :title="'票据查询，项目：'+house_name"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="print">打印</el-button>
        <el-button @click="print_up">纸质发票录入</el-button>
        <el-button @click="selects_s">查询</el-button>
        <div style="margin-top: 10px;">
          <el-descriptions :column="2" border size="mini"  :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="房产信息">
              <el-select v-model="select.house" @change="houses" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="查询方式">
              <Space direction="vertical" size="large">
                <RadioGroup v-model="date.type">
                  <Radio label="模糊查询"></Radio>
                  <Radio label="精确查询"></Radio>
                </RadioGroup>
              </Space>
            </el-descriptions-item>
            <el-descriptions-item  label="缴费日期">
              <el-date-picker v-model="date.date_s" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="date.date_e" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="票据号码">
              <el-input size="mini" v-model="xsc_bill_no" clearable placeholder="票据号码或纸质发票号码"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="票据状态">
              <Space direction="vertical" size="large">
                <RadioGroup v-model="date.bill_type">
                  <Radio label="全部"></Radio>
                  <Radio label="待开票"></Radio>
                  <Radio label="已开票"></Radio>
                </RadioGroup>
              </Space>
            </el-descriptions-item>
            <el-descriptions-item label="票据打印">
              <RadioGroup v-model="date.money">
                  <Radio label="单价不一致合并"></Radio>
                  <Radio label="单价不一致不合并"></Radio>
              </RadioGroup>
            </el-descriptions-item>

            <el-descriptions-item label="汇总方式">
              <RadioGroup v-model="date.groupType" @on-change="orderTypes">
                  <Radio label="票据明细"></Radio>
                  <Radio v-if="date.orderType == '应收费用账单'" label="票据合并"></Radio>
              </RadioGroup>
              <span style="color: red;margin-left: 30px;margin-top: 2px;position: absolute;">选择票据明细查看明细</span>
            </el-descriptions-item>

            <el-descriptions-item label="票据类型">
              <RadioGroup v-model="date.orderType" @on-change="orderTypes">
                  <Radio label="应收费用账单"></Radio>
                  <Radio label="临时费用"></Radio>
                  <Radio label="押金"></Radio>
                  <Radio label="预收款"></Radio>
              </RadioGroup>
            </el-descriptions-item>

            <!-- <el-descriptions-item label="查询方式">
              <Space direction="vertical" size="large">
                <RadioGroup v-model="date.select">
                    <Radio label="明细"></Radio>
                    <Radio label="一张票据一条"></Radio>
                </RadioGroup>
              </Space>
            </el-descriptions-item> -->
            <!-- <el-descriptions-item label="备注">
              <el-input size="mini" v-model="remerks" placeholder="备注"></el-input>
            </el-descriptions-item> -->
          </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
          <span v-if="message_text" style="color: red;margin-left: 15px;">{{message_text}}</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="53vh"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="票据号码" width="130">
              <template slot-scope="scope">
                <div style="color: blue;cursor: pointer;">{{scope.row.xsc_bill_no}}</div>
              </template>
            </el-table-column>
            <el-table-column label="纸质发票" width="130">
              <template slot-scope="scope">
                <div style="color: blue;cursor: pointer;">{{scope.row.paper_bill_no}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="customer" label="姓名" width="100"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" width="260"></el-table-column>
            <el-table-column prop="chargeitem_name" label="收费项目" width="140"></el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="数量" width="80"></el-table-column>
            <el-table-column label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="charge_paid" label="收款金额" width="80"></el-table-column>
            <el-table-column v-if="date.orderType != '押金' && date.orderType != '预收款' " prop="dis_count" label="减免金额" width="80"></el-table-column>
            <el-table-column v-if="date.orderType == '押金'" prop="retreat_money" label="退还押金" width="80"></el-table-column>
            <el-table-column v-if="date.orderType == '预收款'" prop="advance_money" label="预收款余额" width="100"></el-table-column>
            <el-table-column prop="payment" label="支付方式" width="109"></el-table-column>
            <el-table-column prop="operator_date" label="缴款时间" width="150"></el-table-column>
            <el-table-column prop="remark" label="备注" width="200"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages">
        <!-- <Page :total="total" :page-size="page" @on-change="selects" show-total /> -->
        <el-pagination @size-change="selects"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[20,50,100,200,300,400,500]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-dialog>
    <Modal
      v-model="modal1s"
      width="400"
      title="录入纸质发票"
      z-index="100000000000000"
      ok-text="保存"
      @on-ok="paperBill">
      <div style="height: 200px;">
        <el-input size="mini" v-model="paper_bill" clearable placeholder="纸质发票"></el-input>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  // 接受父组件的值
  props: {

  },
  watch:{

  },
  data () {
    return {
      paper_bill:'',
      modal1s:false,
      loading_dade:1,
      dialogVisible:false,
      tableData: [],
      order: [],
      money_val:0,
      money:0,
      total:0,
      page:1,
      pageSize:20,
      date:{
        money:'单价不一致合并',
        date_s:'',
        date_e:'',
        bill_type:'全部',
        type:'模糊查询',
        select:'明细',
        groupType:'票据明细',
        orderType:'应收费用账单',
      },
      select:{
        pay:'',
        house:'',
        name:'',
        date:''
      },
      xsc_bill_no:'',
      house:[],
      remerks:'',
      loading:false,
      pid:'',
      house_name:'',
      message_text:''
    }
  },
  mounted(){

  },
  //事件
  methods: {
    //返回数据
    getInvo(data,house,pid){
      this.pid = pid;
      this.select = data;
      if(this.date.date_s == ''){
        this.date.date_s  = data.date;
        this.date.date_e = data.date;
      }
      this.house = house;
      this.dialogVisible = true;
      this.selects_s(1);
      this.housePid();
    },

    orderTypes(){
      if(this.date.orderType != '应收费用账单'){
        this.date.groupType = '票据明细';
      }
      this.selects_s(1);
    },
    selects_s(){
      this.message_text = '';
      this.money = "加载中";
      this.total = 1;
      this.selects(this.pageSize);
      let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'remerks':this.remerks,'pid':this.pid}
      if(this.date.orderType == '应收费用账单'){
        //分页
        this.$myhttp.post('admin/OrderList/getlnvoSelect_page',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.total = backdata.data.count;
        },err=>{
          // this.$Message.error('请求异常!');
          this.message_text = "请求异常";
        });
        //金额
        this.$myhttp.post('admin/OrderList/getlnvoSelect_money',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.money = backdata.data.money;
        },err=>{
          // this.$Message.error('请求异常!');
          this.message_text = "请求异常";
        });
      }
    },
    selects(e){
      this.message_text = '';
      if(e){
        this.pageSize = e;//1页多少条
      }
      this.loading_dade = 2;
      let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'remerks':this.remerks,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
      this.$myhttp.post('admin/OrderList/getlnvoSelect',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.tableData = backdata.data.data;
        if(this.date.orderType != '应收费用账单'){
          this.total = backdata.data.count;
          this.money = backdata.data.money;
        }
        this.loading_dade = 1;
      },err=>{
        this.loading_dade = 1;
        // this.$Message.error('请求异常!');
        this.message_text = "请求异常";
      });
    },
    handleCurrentChange(e){
      this.page = e;//第几页
      this.selects(this.pageSize);
    },
    handleClose(done) {
      done();
    },
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map(req=>{
        money = Number(money) + Number(req.charge_paid);
      })
      this.money_val = money.toFixed(2);
    },
    print(){
      this.message_text = "";
      let id = this.order.map(req=>{return req.id}).join(',');
      if(id == ''){
        // this.$Message.error('请选择打印项!');
        this.message_text = "请选择打印项";
      }else{
        this.$parent.prin(id,this.date,this.pid);
      }
    },
    //纸质发票录入
    print_up(){
      this.message_text = "";
      let id = this.order.map(req=>{return req.id}).join(',');
      if(id == ''){
        this.message_text = "请选择需要录入纸质发票的项!";
      }else{
        let boot = false;
        if(this.date.orderType == "应收费用账单"){
          this.modal1s = true;
          boot = true;
        }
        if(this.date.orderType == "临时费用"){
          this.modal1s = true;
          boot = true;
        }
        if(boot == false){
          this.message_text = "纸质发票只能录入：(应收费用账单和临时费用)!";
        }
      }
    },
    //纸质发票录入
    paperBill(){
      let id = this.order.map(req=>{return req.id}).join(',');
      let data = {'paper_bill':this.paper_bill,'id':id,'pid':this.pid};
      if(id == ''){
        this.message_text = "请选择需要录入纸质发票的项!";
        this.modal1s = false;
      }else{
        this.$myhttp.post('admin/OrderList/paperBill',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data_req = backdata.data;
          if(data_req.code == 200){
            this.paper_bill = '';
            this.modal1s = false;
            this.selects(this.pageSize);
          }else{
            this.message_text = data_req.message;
          }
        },err=>{
          this.message_text = "请求异常";
        });
      }
    },
    //远程搜索
    remoteMethod(query){
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name1?house_name='+encodeURIComponent(query)+'&pid='+this.pid,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.house = backdata.data.data;
        });
      }
    },
    //更换项目id
    houses(e){
      if(e){
        this.house.map(req=>{
          if(req.house == e){
            //this.pid = req.erp_pindex_id;
          }
        })
      }
      this.housePid();
    },
    //查询当前项目
    housePid(){
      this.$myhttp.get('admin/common/house_pid?pid='+this.pid+"&house="+encodeURIComponent(this.select.house),{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            this.house_name = backdata.data.data.name;
            this.pid = backdata.data.data.id;
          }
      });
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/InvoicingSelect.vue